module.exports = __webpack_public_path__ + "static/img/dl_tron.3f62c8dc.png";